import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-06d1f9bd")

_pushScopeId("data-v-06d1f9bd")
const _hoisted_1 = /*#__PURE__*/_createVNode("h3", null, "患者検索", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("検索ワード ")
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "gender-label" }, "性別", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("男性")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("女性")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("その他")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_top_label_edit_box = _resolveComponent("top-label-edit-box")
  const _component_toggle_switch = _resolveComponent("toggle-switch")
  const _component_vue_content = _resolveComponent("vue-content")

  return (_openBlock(), _createBlock(_component_vue_content, null, {
    default: _withId(() => [
      _hoisted_1,
      _createVNode("div", null, [
        _createVNode(_component_top_label_edit_box, {
          class: "vue-content-edit-box",
          title: "検索ワード",
          placeholder: "名前、かな、電話番号",
          modelValue: _ctx.searchWord,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchWord = $event))
        }, {
          default: _withId(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode("div", null, [
        _hoisted_3,
        _createVNode(_component_toggle_switch, {
          modelValue: _ctx.male,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.male = $event))
        }, {
          default: _withId(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_toggle_switch, {
          modelValue: _ctx.female,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.female = $event))
        }, {
          default: _withId(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_toggle_switch, {
          modelValue: _ctx.other,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.other = $event))
        }, {
          default: _withId(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }))
})